// AmenitiesGridSkeleton.js
import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const AmenitiesGridSkeleton = () => {
  return (
    <Grid container spacing={2}>
      {[...Array(8)].map((_, index) => (
        <Grid item xs={6} sm={4} md={3} key={index}>
          <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 1 }} />
        </Grid>
      ))}
    </Grid>
  );
};

export default AmenitiesGridSkeleton;